import React from 'react';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { font } from '@styles/fonts';

interface MachineChartProps {
  scale: ScaleFunction;
  font: typeof font;
}

const MachineChart: React.FC<MachineChartProps> = ({ font, scale }) => {
  return null;
};

export default MachineChart;
